import { render, staticRenderFns } from "./script-settings.vue?vue&type=template&id=5d7bc4fb"
import script from "./script-settings.vue?vue&type=script&lang=js"
export * from "./script-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports